import './App.css';
import React from 'react';

// Bootstrap Styles
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/js/src/collapse.js';

// Mui Core
import { styled } from '@material-ui/core/styles';

// Theme imports
import GlobalStyle from './theme/globalStyle';
import ThemeContext from './Redux/context/ThemeContext';
import colors from './theme/colors';
import breakpoints from './theme/breakpoints';
// end theme imports

// Custom Components
import AuthRoutes from './Routes';
import LoginRoutes from './Routes/LoginRoutes';
import { ConfirmationModalProvider } from './Redux/context/modalContext';
import { Flex } from './components/Layouts';
import Toolbar from './components/Toolbar';
import Sidenav from './components/SideNav';
import { Context as AuthContext } from './Redux/context/AuthContext';
import Alert from './components/Alert';

// Redux
import { useSelector, useDispatch } from 'react-redux';
import { getTieirng } from './Redux/actions/tieringAction';
import { getApobSellerList } from './Redux/actions/abopSellerAction';
import { getAPICredential } from './Redux/actions/apiCredentialAction';
import { setApobSeller } from './Redux/actions/setApobSellerAction';

import Modal from './components/Modal';
import { ModalProvider } from './context/ModalPortalContext';
import {
  moengageTrackEvent,
  checkMoengageID,
  getRouteParams,
} from './Analytics/moengageEventFunction';
import { useLocation } from 'react-router-dom';
import NewHeaderComponent from './components/NewHeader/NewHeader';
import { ThemeProvider } from '@material-ui/core/styles';
import theme from './theme/globalFonts';

import getApobSupplierId from './utils/getApobSupplierId';

const Main = styled('main')(({ theme, open, journeyCompleted }) => ({
  flexGrow: 1,
  backgroundColor: colors.lightBG,
  // overflow: 'auto',
  height: '100vh',
  width: '100vw',
  // paddingTop: journeyCompleted ? breakpoints.toolbarHeight + 80 + 'px' : '',
  paddingTop: '100px',
  paddingBottom: journeyCompleted ? breakpoints.toolbarHeight + 40 + 'px' : '',
  padding: journeyCompleted ? theme.spacing(3) : '',
  transition: theme.transitions.create('margin', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `-${breakpoints.drawerWidth}px`,
  ...(open && {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  }),
}));

const App = () => {
  const { state, checkLogin } = React.useContext(AuthContext);
  const { isFalconSeller, isFalconAdmin, isFalconMaster, isFalconOps } = state.roleCheck;
  const isAuthorized =
    state.isSignedIn &&
    state.tnc &&
    state.working &&
    (isFalconSeller || isFalconAdmin || isFalconMaster || isFalconOps);
  const dispatch = useDispatch();
  const location = useLocation();

  const loginData = localStorage.getItem('login_data')
    ? JSON.parse(localStorage.getItem('login_data'))
    : null;

  const { tierDetails } = useSelector((state) => state.user);
  const { apobSupplierID } = getApobSupplierId();
  React.useEffect(() => {
    checkLogin();
  }, []);

  React.useEffect(() => {
    if (isAuthorized) {
      let { user_id, isIrnNeeded, isClearTaxInvoice } = JSON.parse(
        localStorage.getItem('login_data')
      );
      dispatch(setApobSeller({ apobSupplierID: user_id, isIrnNeeded, isClearTaxInvoice }));
      dispatch(getApobSellerList(JSON.parse(localStorage.getItem('login_data'))?.user_id));
      dispatch(getTieirng(apobSupplierID));
      dispatch(getAPICredential(apobSupplierID));
    }
  }, [dispatch, isAuthorized]);

  const [open, setOpen] = React.useState(true);
  const [modalOpen, setOpenModal] = React.useState(false);

  React.useEffect(() => {
    const handleWidth = (event) => {
      let screenWidth = event.target.innerWidth;
      if (screenWidth > 20) setOpen(true);
      else setOpen(false);
    };
    window.addEventListener('resize', handleWidth);
    window.addEventListener('click', (e) => {
      let idDetails = checkMoengageID(e.target);
      if (idDetails.idExists) {
        idDetails.data = JSON.parse(idDetails.data);
        moengageTrackEvent(idDetails?.data?.eventName, idDetails?.data);
      }
    });
    return () => {
      window.removeEventListener('resize', handleWidth);
      window.removeEventListener('click', (e) => {
        // //console.log('the target:', e.target.id);
      });
    };
  }, []);

  React.useEffect(() => {
    let eventDetails = getRouteParams(location.pathname);
    if (eventDetails) {
      eventDetails.params.source =
        performance.navigation.type == performance.navigation.TYPE_RELOAD
          ? 'Page reloaded'
          : location?.state?.source
          ? location.state.source
          : 'url change';
      moengageTrackEvent(eventDetails.eventName, eventDetails.params);
    }
  }, [location]);

  return (
    <ThemeProvider theme={theme}>
      <ModalProvider>
        <ConfirmationModalProvider>
          <ThemeContext id="scrollableDiv">
            {isFalconSeller || isFalconAdmin || isFalconMaster || isFalconOps ? (
              <Flex>
                <NewHeaderComponent />
                <GlobalStyle />
                <Alert />
                {modalOpen && (
                  <Modal
                    open={modalOpen}
                    onClose={() => setOpenModal(false)}
                    template={tierDetails?.response}
                  />
                )}
                <React.Fragment>
                  {/* {loginData?.userJourneyCompleted && (
                  <Toolbar toggleNav={() => setOpen(!open)} open={open} />
                )} */}
                  {(loginData?.userJourneyCompleted || loginData?.isAdmin) && (
                    <Sidenav
                      open={open}
                      toggleNav={setOpen}
                      tier={tierDetails?.tier}
                      onBadgeClick={() => setOpenModal(true)}
                    />
                  )}
                  <Main
                    open={open}
                    journeyCompleted={loginData?.userJourneyCompleted || loginData?.isAdmin}
                  >
                    <AuthRoutes />
                  </Main>
                </React.Fragment>
              </Flex>
            ) : (
              <LoginRoutes />
            )}
          </ThemeContext>
        </ConfirmationModalProvider>
      </ModalProvider>
    </ThemeProvider>
  );
};

export default App;
